export default {
  name: (state) => state.name,
  stbAxios: (state) => state.stbAxios,
  silentAxiosError: (state) => state.silentAxiosError,
  isNavigationBlocked: (state) => state.isNavigationBlocked
};
